import {
  InvitationCheckingRequest,
  postCheckInvitation,
  postForgotPasswordChecking,
  SuccessResponse,
} from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import { InvitationStep } from '../../forms';
import { Self } from '../common';

export function* invitationCheckRequest(
  self: Self,
  body: InvitationCheckingRequest,
  goToLogin: () => void
): Generator<Promise<FlowReturn<SuccessResponse>>> {
  self.isProgress = true;
  try {
    const response = yield postCheckInvitation(body);
    const { status } = (response as SuccessResponse).data;
    if (status.code === 1000) {
      return Promise.resolve(ResponseMessage.OK);
    }
    if ([1102, 1103, 1105, 8900].includes(status.code)) {
      self.alert.title = 'invitations.expired_title';
      self.alert.message = 'invitations.expired_and_recovery_desc';
      self.alert.handleOK = goToLogin;
      self.alert.open = true;
      return Promise.resolve(ResponseMessage.Error);
    }
    if (status.code === 1104) {
      return Promise.resolve(InvitationStep.Duplicate);
    }
    goToLogin();
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isProgress = false;
  }
}

export function* forgotPassCheckRequest(
  self: Self,
  body: InvitationCheckingRequest,
  goToLogin: () => void
): Generator<Promise<FlowReturn<SuccessResponse>>> {
  self.isProgress = true;
  try {
    const response = yield postForgotPasswordChecking(body);
    const { status } = (response as SuccessResponse).data;
    if (status.code === 1000) {
      return Promise.resolve(ResponseMessage.OK);
    }
    if (status.code === 1102) {
      self.alert.title = status.messages[0];
      self.alert.handleOK = goToLogin;
      self.alert.open = true;
      return Promise.resolve(ResponseMessage.Error);
    }
    if ([1103, 1105].includes(status.code)) {
      self.alert.title = 'The recovery link is expired';
      self.alert.message =
        'Please contact TFSPH Merchant call center to send you another invitation';
      self.alert.handleOK = goToLogin;
      self.alert.open = true;
      return Promise.reject(ResponseMessage.Error);
    }
    if (status.code === 1104) {
      return Promise.resolve(InvitationStep.Duplicate);
    }
    goToLogin();
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isProgress = false;
  }
}
